const o = new URL("../../../assets/icon-footer-logos-D908KRZL.png", import.meta.url).href;
export {
  o as default
};
//# sourceMappingURL=icon-footer-logos.png.js.map
